// Thin HTTP client used across the web app. Attaches the user's auth
// token to every request.
//
// Flask-Security (server) is configured with
// `SECURITY_API_ENABLED_METHODS=["token","basic"]`, which means it
// reads the token from the `Authentication-Token` header — NOT the
// standard `Authorization: Bearer …`. We send both headers so:
//   - new endpoints (e.g. /api/admin/*) that rely on
//     @auth_required('token') see the right header and authenticate,
//   - existing routes that happened to work via session cookies still
//     work (and now also work via the token directly if the cookie
//     is missing).

import Const from '../utils/Constants';
import axios from 'axios';

function authHeaders() {
    // The login flow writes the token to Const.AUTH_TOKEN
    // (see reducers/authReducer.js). Historically this file read
    // Const.TOKEN, which doesn't exist in Constants.js — every
    // localStorage.getItem(undefined) returned null and the web app
    // ran on session cookies alone. Reading AUTH_TOKEN unlocks
    // header-based auth for new endpoints (e.g. /api/admin/*).
    const token = localStorage.getItem(Const.AUTH_TOKEN);
    if (!token) return {};
    return {
        // Flask-Security's `token` auth method reads this header name.
        'Authentication-Token': token,
        // Legacy header — kept so any older middleware that reads
        // `Authorization` stays happy. Flask-Security ignores it
        // unless `basic` auth is enabled, which we don't use.
        'Authorization': 'Bearer ' + token,
    };
}

function defaultHeaders() {
    return {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        ...authHeaders(),
    };
}

const GET = async (path) => {
    const res = await axios.get(path, { headers: defaultHeaders() });
    return res.data;
};

const POST = async (path, data) => {
    const res = await axios.post(path, data, { headers: defaultHeaders() });
    return res.data;
};

const PUT = async (path, data) => {
    const res = await axios.put(path, data, { headers: defaultHeaders() });
    return res.data;
};

const DELETE = async (path, body) => {
    const res = await fetch(path, {
        method: 'DELETE',
        headers: defaultHeaders(),
        body: body !== undefined ? JSON.stringify(body) : undefined,
    });
    return res.json();
};

export { GET, POST, PUT, DELETE };

const Http = { GET, POST, PUT, DELETE };
export default Http;
